export default "/images/9a67e0c106e25feeba94046c1cc89988.avif";